<template>
	<v-list-item>
			<v-list-item-content>
				<v-text-field
					:rules='[v => !!v || "Text is mandatory"]'
					class='fullwidth'
					filled
					label='Text'
					prepend-icon='mdi-text'
					required
					v-model='data.title'
				></v-text-field>
			</v-list-item-content>
		</v-list-item>
</template>

<script>
	export default {
		name: 'BenefitForm',
		props: ['data']
	}
</script>
